import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SmartRecoState } from '@app/pages/smart-reco/store/smart-reco.state';
import { smartRecoFeatureKey } from '@app/pages/smart-reco/store/smart-reco-feature-key';

const selectState = createFeatureSelector<SmartRecoState>(smartRecoFeatureKey);

export const selectNutritionalAssessmentMacronutrients = createSelector(
  selectState,
  (state) => state?.nutritionalAssessment?.macroNutrients,
);

export const selectNutritionalAssessmentOtherNutrients = createSelector(
  selectState,
  (state) => state?.nutritionalAssessment?.otherNutrients,
);

export const selectNutritionalAssessmentBenefitClaim = createSelector(selectState, (state) => state?.nutritionalAssessment?.benefits);

export const selectNutritionalAssessmentHasError = createSelector(selectState, (state) => !!state?.nutritionalAssessmentHasError);
export const selectNutritionalAssessmentLoading = createSelector(selectState, (state) => state?.nutritionalAssessmentLoading);
